import React from "react";

const HowOlaplexWhat = () => {
  return (
    <div className="blogHead-content">
      <h2>What Makes Olaplex Unique?</h2>
      <p>
        Olaplex is a revolutionary hair treatment that uses a patented active
        ingredient, Bis-Aminopropyl Diglycol Dimaleate, to repair the broken
        disulfide bonds in the hair. Disulfide bonds are the backbone of hair
        structure, and they can become damaged due to various factors, including
        coloring, heat styling, and environmental exposure.
      </p>
      <p>
        By reconnecting these broken bonds, Olaplex helps restore the integrity,
        strength, and shine of your hair, making it an essential part of any
        hair care routine for those who color their hair frequently.
      </p>
    </div>
  );
};

export default HowOlaplexWhat;
